import axios from 'axios';

const api = axios.create({
  baseURL: "https://"+localStorage.getItem("sv")+process.env.REACT_APP_API_HOST,
  headers: { 'Content-Type': "application/json" }
});

/*const api = axios.create({
  baseURL: process.env.REACT_APP_API_HOST,
  headers: { 'Content-Type': "application/json" }
});*/


export default api